<p-dialog [(visible)]="displayDialog" [modal]="true" [style]="{width: '600px'}" (onHide)="cancel()">
    <ng-template pTemplate="header">
        <div class="w-full text-center font-22 font-weight-600" translate>collaterals.restitution
        </div>
    </ng-template>

    <div>
        <form #form="ngForm" (ngSubmit)="onSave()">
            <div class="m-auto">
                <div class="row h-68">
                    <div class="col-5 text-right font-14 pr-0 pt-10" translate>common.document_number<span class="requireSym">*</span>
                    </div>
                    <div class="col-7">
                        <input type="text" name="documentNumber" class="form-control" maxlength="10" required placeholder=""
                                #documentNumber="ngModel" [(ngModel)]="collateralRestitution.documentNumber">
                        <small class="text-danger">
                            {{documentNumber.valid || !submittedForm ? '&nbsp;' : 'This field is required'}}
                        </small>
                    </div>
                </div>
                <div class="row h-68">
                    <div class="col-5 text-right font-14 pr-0">
                        <label class="d-flex flex-wrap position-relative"
                               style="white-space: normal;">
                        <span class="flex-grow-1 mr-6p" translate>collaterals.agreement_number
                        </span>
                            <span class="requireSym position-absolute" style="right: 0; top: 0;">*</span>
                        </label>
                    </div>
                    <div class="col-7">
                        <input type="text" name="agreementNumber" class="form-control" placeholder="" readonly
                                    #agreementNumber="ngModel" [ngModel]="collateralRestitution.collateralAgreementNumber">
                    </div>
                </div>
                <div class="row h-68">
                    <div class="col-5 text-right font-14 pr-0 pt-10" translate>common.date<span class="requireSym">*</span>
                    </div>
                    <div class="col-7">
                        <p-calendar [(ngModel)]="collateralRestitution.date" class="w-full" [showIcon]="true"
                                    [showOnFocus]="false" placeholder="dd-mm-yyyy" dataType="string"
                                    dateFormat="dd-mm-yy" [style]="{'width':'100%'}"
                                    [inputStyle]="{'width':'100%'}" required
                                    name="date" #date="ngModel"
                                    [monthNavigator]="true" [yearNavigator]="true" [yearRange]="yearRange">
                        </p-calendar>
                        <small class="text-danger">
                            {{date.valid || !submittedForm ? '&nbsp;' : 'This field is required'}}
                        </small>
                    </div>
                </div>
                <div class="row h-68">
                    <div class="col-5 text-right font-14 pr-0 pt-10"><span translate>collaterals.outstanding_amount</span><span class="requireSym">*</span>
                    </div>
                    <div class="col-7">
                        <p-inputNumber name="amount"
                                    required
                                   [disabled]="true"
                                   [minFractionDigits]="2"
                                   [min]="0"
                                   placeholder="" #amount="ngModel" [ngModel]="collateralRestitution.amount">
                        </p-inputNumber>
                    </div>
                </div>
                <div class="row h-68">
                    <div class="col-5 text-right font-14 pr-0 pt-10" translate>collaterals.outstanding_quantity<span class="requireSym">*</span>
                    </div>
                    <div class="col-7">
                        <p-inputNumber name="quantity"
                                    required
                                   [disabled]="true"
                                   [min]="0"
                                   [useGrouping]="false"
                                   placeholder="" #quantity="ngModel" [ngModel]="collateralRestitution.quantity">
                        </p-inputNumber>
                    </div>
                </div>
                <div class="row h-68">
                    <div class="col-5 text-right font-14 pr-0 pt-10" translate>common.purpose<span class="requireSym"></span>
                    </div>
                    <div class="col-7">
                        <input type="text" name="purpose" class="form-control" placeholder=""
                                #purpose="ngModel" [(ngModel)]="collateralRestitution.purpose" >
                    </div>
                </div>
                <div class="row h-68">
                    <div class="col-5 text-right font-14 pr-0 pt-10" translate>common.branch<span class="requireSym">*</span>
                    </div>
                    <div class="col-7">
                        <p-dropdown [options]="branchCodeList" name="branch"
                                    placeholder="Select branch" optionLabel="name" optionValue="id"
                                    [(ngModel)]="collateralRestitution.branchId" #branch="ngModel"
                                    (onChange)="changeBranch($event.value)" class="w-full"
                                    [style]="{'width': '100%'}">
                        </p-dropdown>
                        <small class="text-danger">
                            {{branch.valid || !submittedForm ? '&nbsp;' : 'This field is required'}}
                        </small>
                    </div>
                </div>
            </div>
            
            <div class="form-input-row pt-20">
                <div class="d-flex justify-content-center">
                    <app-button id="collateral-restitution" buttonClass="btn-primary"
                                buttonType="button" (clickEvent)="onSave()"
                                [isDisabled]="form.invalid">
                        <span translate>buttons.save</span>
                    </app-button>
                    <app-button id="cancel-savings" buttonClass="btn-secondary mr-0"
                                buttonType="button" (clickEvent)="cancel()">
                        <span translate>buttons.cancel</span>
                    </app-button>
                    
                </div>
            </div>
        </form>
    </div>
</p-dialog>
